<template>
  <section>
    <List
      :title="table.title"
      :breadcumb="table.breadcumb"
      :dataTable="table.dataTable"
      :showPagination="false"
    >
      <template v-slot:button>
        <div>
          <button
            type="button"
            class="btn btn-primary"
            data-toggle="modal"
            data-target="#Modal_TambahAmandemenProsesStatus"
          >
            <i class="fa fa-plus fa-l" aria-hidden="true"></i> Tambah Amandemen
            Proses Status
          </button>
        </div>
      </template>

      <template v-slot:search>
        <div class="input-group form-search-rounded">
          <input
            class="form-control py-2 border-right-0 border"
            v-model.lazy="search"
            type="search"
            id="example-search-input"
            placeholder="Cari amandemen proses status disini.."
          />
          <span class="input-group-append">
            <div class="input-group-text bg-transparent">
              <a href="#" class="text-blue"><i class="fa fa-search"></i></a>
            </div>
          </span>
        </div>
      </template>

      <template v-slot:columnHeader>
        <thead>
          <tr>
            <th>No.</th>
            <th>Level</th>
            <th>Nama</th>
            <th width="10%">Aksi</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ rows }">
        <tbody>
          <tr
            v-for="(data, index) in rows"
            :key="data.id"
            draggable="true"
            @dragstart="onDragStart(index)"
            @dragend="onDragEnd"
            @dragenter.prevent="onDragEnter(index)"
            @dragleave="onDragLeave(index)"
            @dragover.prevent
            @drop="onDrop(index)"
            :class="{
              'dragging-row': dragIndex === index,
              'drop-target-row': dropTargetIndex === index && dragIndex !== index,
            }"
            style="cursor: move"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ data.level }}</td>
            <td v-html="data.name"></td>
            <td>
              <div class="btn-action-block">
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#Modal_DataAmandemenProsesStatus"
                  @click="detail = JSON.parse(JSON.stringify(data))"
                  class="btn btn-icon-small btn-success-trans waves-effect waves-light"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#Modal_EditAmandemenProsesStatus"
                  @click="detail = JSON.parse(JSON.stringify(data))"
                  class="btn btn-icon-small btn-warning-trans waves-effect waves-light"
                  style="margin-left: 2px"
                >
                  <i class="fa fa-pencil"></i>
                </button>
                <button
                  type="button"
                  @click="destroy(data)"
                  class="btn btn-icon-small btn-danger-trans waves-effect waves-light"
                  id="confirm-text"
                  style="margin-left: 2px"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </template>

      <template v-slot:action="{ data }">
        <div class="btn-action-block">
          <button
            type="button"
            data-toggle="modal"
            data-target="#Modal_DataAmandemenProsesStatus"
            @click="detail = JSON.parse(JSON.stringify(data))"
            class="btn btn-icon-small btn-success-trans waves-effect waves-light"
          >
            <i class="fa fa-eye"></i>
          </button>
          <button
            type="button"
            data-toggle="modal"
            data-target="#Modal_EditAmandemenProsesStatus"
            @click="detail = JSON.parse(JSON.stringify(data))"
            class="btn btn-icon-small btn-warning-trans waves-effect waves-light"
            style="margin-left: 2px"
          >
            <i class="fa fa-pencil"></i>
          </button>
          <button
            type="button"
            @click="destroy(data)"
            class="btn btn-icon-small btn-danger-trans waves-effect waves-light"
            id="confirm-text"
            style="margin-left: 2px"
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </template>
    </List>

    <!-- Modal Tambah -->
    <div
      class="modal fade text-left"
      id="Modal_TambahAmandemenProsesStatus"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel160"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-primary white">
            <h5 class="modal-title" id="myModalLabel160">
              Tambah Amandemen Proses Status
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ValidationObserver v-slot="{ invalid }" ref="observer">
            <div class="modal-body">
              <ValidationProvider
                name="model.level"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Level</label>
                  <input
                    type="number"
                    v-model="model.level"
                    class="form-control"
                    placeholder="Masukan level"
                    aria-describedby="helpId"
                    required=""
                  />
                  <small class="text-muted danger" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
              <ValidationProvider
                name="model.name"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Nama Status</label>
                  <input
                    type="text"
                    v-model="model.name"
                    class="form-control"
                    placeholder="Masukan nama status"
                    aria-describedby="helpId"
                    required=""
                  />
                  <small class="text-muted danger" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-primary"
                data-dismiss="modal"
              >
                Tutup
              </button>
              <button
                type="button"
                :disabled="invalid"
                @click="save()"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                Tambah Status
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- Modal Edit -->
    <div
      class="modal fade text-left"
      id="Modal_EditAmandemenProsesStatus"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel160"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-primary white">
            <h5 class="modal-title" id="myModalLabel160">
              Edit Amandemen Proses Status
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ValidationObserver v-slot="{ invalid }" ref="observerEdit">
            <div class="modal-body">
              <ValidationProvider
                name="detail.level"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Level</label>
                  <input
                    type="number"
                    v-model="detail.level"
                    class="form-control"
                    placeholder="Masukan level"
                    aria-describedby="helpId"
                    required=""
                  />
                  <small class="text-muted danger" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
              <ValidationProvider
                name="detail.name"
                v-slot="{ errors }"
                rules="required"
              >
                <div
                  class="form-group"
                  :class="{ 'validation-warning': errors[0] }"
                >
                  <label for="">Nama Status</label>
                  <input
                    type="text"
                    v-model="detail.name"
                    class="form-control"
                    placeholder="Masukan nama status"
                    aria-describedby="helpId"
                    required=""
                  />
                  <small class="text-muted danger" v-if="errors[0]">{{
                    errors[0]
                  }}</small>
                </div>
              </ValidationProvider>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-primary"
                data-dismiss="modal"
              >
                Tutup
              </button>
              <button
                type="button"
                :disabled="invalid"
                @click="update()"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                Edit Status
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- Modal Detail -->
    <div
      class="modal fade text-left"
      id="Modal_DataAmandemenProsesStatus"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-primary white">
            <h5 class="modal-title" id="myModalLabel160">
              Data Amandemen Proses Status
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">Level</label>
              <input
                type="text"
                class="form-control"
                :value="detail.level"
                readonly
              />
            </div>
            <div class="form-group">
              <label for="">Nama Status</label>
              <input
                type="text"
                class="form-control"
                :value="detail.name"
                readonly
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              data-dismiss="modal"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import List from "@/components/List.vue";

export default {
  components: {
    List,
  },
  data() {
    return {
      table: {
        title: "Amandemen Proses Status",
        breadcumb: "Master Data",
        dataTable: {
          lists: [],
          columns: ["level", "name"],
        },
      },
      search: null,
      detail: {
        level: null,
        name: null,
      },
      model: {
        level: null,
        name: null,
      },
      dragIndex: null,
      dropTargetIndex: null,
      isUpdatingLevel: false,
    };
  },
  mounted() {
    let _ = this;
    _.getList();
    _.$root.$on("paginate", (data) => {
      _.getList(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("paginate");
  },
  methods: {
    getList(page = 1) {
      let _ = this;
      _.axios
        .get(
          "/v3/amandemen-proses-status?key=" +
            _.search +
            "&page=" +
            page +
            "&per_page=999",
        )
        .then((resp) => {
          const rows = resp.data.data.rows;
          if (Array.isArray(rows.data)) {
            rows.data = rows.data.sort(
              (a, b) => Number(a.level || 0) - Number(b.level || 0),
            );
          }
          _.table.dataTable.lists = rows;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    onDragStart(index) {
      this.dragIndex = index;
    },
    onDragEnd() {
      this.dragIndex = null;
      this.dropTargetIndex = null;
    },
    onDragEnter(index) {
      if (this.dragIndex === null || this.dragIndex === index) {
        return;
      }
      this.dropTargetIndex = index;
    },
    onDragLeave(index) {
      if (this.dropTargetIndex === index) {
        this.dropTargetIndex = null;
      }
    },
    onDrop(dropIndex) {
      if (this.dragIndex === null || this.isUpdatingLevel) {
        return;
      }

      const fromIndex = this.dragIndex;
      this.dragIndex = null;
      this.dropTargetIndex = null;

      if (fromIndex === dropIndex) {
        return;
      }

      const list = this.table.dataTable.lists?.data;
      if (!Array.isArray(list)) {
        return;
      }

      const reordered = [...list];
      const [movedItem] = reordered.splice(fromIndex, 1);
      reordered.splice(dropIndex, 0, movedItem);

      this.table.dataTable.lists.data = reordered.map((item, index) => ({
        ...item,
        level: index + 1,
      }));

      this.bulkUpdateLevel();
    },
    bulkUpdateLevel() {
      const _ = this;
      const list = _.table.dataTable.lists?.data || [];
      const payload = {
        items: list.map((item, index) => ({
          id: item.id,
          level: index + 1,
        })),
      };

      _.isUpdatingLevel = true;
      _.axios
        .post("/v3/amandemen-proses-status/bulk-update-level", payload)
        .then((resp) => {
          if (resp.status) {
            _.$toast.success("Urutan level berhasil diubah");
            _.getList();
            return;
          }
          _.$toast.warning("Urutan level gagal diubah");
          _.getList();
        })
        .catch((err) => {
          console.log(err.response);
          _.$toast.warning(
            err.response?.data?.message || "Urutan level gagal diubah",
          );
          _.getList();
        })
        .finally(() => {
          _.isUpdatingLevel = false;
        });
    },
    save() {
      let _ = this;
      _.axios
        .post("/v3/amandemen-proses-status", _.model)
        .then((resp) => {
          if (resp.status) {
            _.getList();
            _.$toast.success("Data Berhasil Disimpan");
          } else {
            console.log("Failed");
            _.$toast.warning("Data Gagal Disimpan");
          }
          _.model = {
            level: null,
            name: null,
          };
          _.$refs.observer.reset();
        })
        .catch((err) => {
          console.log(err.response);
          _.model = {
            level: null,
            name: null,
          };
          _.$refs.observer.reset();
          _.$toast.warning(err.response.data.message || "Data Gagal Disimpan");
        });
    },
    update() {
      let _ = this;
      _.axios
        .put("/v3/amandemen-proses-status/" + _.detail.id, _.detail)
        .then((resp) => {
          if (resp.status) {
            _.getList();
            _.$toast.success("Data Berhasil Diubah");
          } else {
            console.log("Failed");
            _.$toast.warning("Data Gagal Diubah");
          }
          _.$refs.observerEdit.reset();
        })
        .catch((err) => {
          console.log(err.response);
          _.$refs.observerEdit.reset();
          _.$toast.warning(err.response.data.message || "Data Gagal Diubah");
        });
    },
    destroy(x) {
      let _ = this;
      this.$swal
        .fire({
          title: "Hapus Data Ini?",
          text: "Anda mungkin tidak akan mengembalikannya lagi!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#44A8BD",
          cancelButtonColor: "#D95E6A",
          confirmButtonText: "Ya, Hapus!",
          cancelButtonText: "Batal",
        })
        .then((result) => {
          if (result.value) {
            _.axios
              .delete("/v3/amandemen-proses-status/" + x.id)
              .then((resp) => {
                if (resp.status) {
                  _.getList();
                  this.$swal.fire({
                    title: "Terhapus!",
                    text: "Data berhasil dihapus",
                    icon: "success",
                    confirmButtonColor: "#37BA71",
                    confirmButtonText: "OK",
                  });
                } else {
                  console.log("Failed");
                }
              })
              .catch((err) => {
                console.log(err.response);
                _.$toast.warning(
                  err.response.data.message || "Data Gagal Dihapus",
                );
              });
          }
        });
    },
  },
  watch: {
    search() {
      this.getList();
    },
  },
};
</script>

<style scoped>
.drop-target-row {
  background-color: #e8f4ff;
  outline: 2px dashed #44a8bd;
  outline-offset: -2px;
}
</style>
